export default "__VITE_ASSET__BiMDWEVH__"